import notificationStreamModule from "../notificationStreamModule";

function privateMessage(notificationStreamUtility, $log) {
    "ngInject";
    return {
        restrict: "A",
        replace: true,
        scope: {
            notification: "=",
            appMeta: "=",
            library: "=",
            interactNotification: "&"
        },
        templateUrl: notificationStreamUtility.templates.privateMessageTemplate,
        link: function (scope, element, attrs) {
            var init = function () {
                scope.notificationSourceType = notificationStreamUtility.notificationSourceType;
                scope.friendRequestLink = notificationStreamUtility.layout.friendRequestLink;
                scope.privateMessageLayout = {
                    displayUserId: null,
                    displayUserName: "",
                    messagePreview: "",
                    isStacked: false
                }
                var metaData = scope.notification.metadataCollection;
                var notificationType = scope.notification.notificationSourceType;
                if (scope.notification.eventCount > 1 || (metaData && metaData.length === 0)) {
                    scope.privateMessageLayout.isStacked = true;
                }

                if (metaData && metaData.length > 0) {
                    var user = notificationStreamUtility.normalizeUser(notificationType, metaData[0]);
                    scope.privateMessageLayout.displayUserId = user.userId;
                    scope.privateMessageLayout.displayUserName = user.userName;
                    scope.privateMessageLayout.messagePreview = metaData[0].BodyPreview;
                }
            }

            init();
        }
    }
}

notificationStreamModule.directive("privateMessage", privateMessage);

export default privateMessage;